import type { PropsWithChildren } from 'react';

import { Background } from '@/components/escript/onboarding/Onboarding.styles';

export function OnboardingBackground({ children }: PropsWithChildren) {
  return <Background>{children}</Background>;
}
